//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import hasWindow from '../../mixins/hasWindow'

import IconArticle from '~/assets/svg/article.svg?inline'

export default {
  components: { IconArticle },

  mixins: [hasWindow],
}
